import React, { useContext, useState, useEffect } from 'react';
import { LiveContext } from 'src/context/LiveContext';
import classNames from 'classnames';
import { useLiveTimer } from 'utils/useLiveTimer';
import styles from './LiveHeader.module.scss';

export function LiveCountdown() {
  const { currentScreen, timer, timerPausedSecondsRemaining } = useContext(LiveContext);
  const [showTimer, setShowTimer] = useState<boolean>(false);
  const timerDate = new Date(timer || '');
  const { seconds, minutes } = useLiveTimer({ timer: timerDate });
  useEffect(() => {
    if (timer) {
      setShowTimer(true);
    } else {
      setShowTimer(false);
    }
  }, [timer]);
  useEffect(() => {
    setShowTimer(false);
  }, [currentScreen]);
  if (!showTimer) {
    return null;
  }
  const showRed = seconds === '00' && minutes === '00';
  if (timerPausedSecondsRemaining) {
    return (
      <div className={classNames(styles.liveCountdown)}>
        {Math.floor(timerPausedSecondsRemaining / 60)
          .toFixed(0)
          .padStart(2, '0')}
        :
        {Math.floor(timerPausedSecondsRemaining % 60)
          .toFixed(0)
          .padStart(2, '0')}
      </div>
    );
  }
  return (
    <div className={classNames(styles.liveCountdown, { [styles.liveCountdownExpired]: showRed })}>
      {minutes}:{seconds}
    </div>
  );
}
